module.exports = __webpack_public_path__ + "b5d56051cbe160bce8b008b0952cc36c.svg";